import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FieldErrorAndDescription, FieldErrorAndDescriptionProps } from 'shared/components/form/field-error-and-description';
import { FieldLabel, FieldLabelProps } from 'shared/components/form/field-label';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
type DeadlineSettingsExpirationInputProps = FieldErrorAndDescriptionProps & FieldLabelProps & {
  value: number;
  onChange: (value: number) => void;
  isFetching: boolean;
  wrapperClassName?: string;
};
function DeadlineSettingsExpirationInput(t0) {
  const $ = _c(26);
  const {
    onChange,
    value,
    isFetching,
    label,
    labelClassName,
    required: t1,
    wrapperClassName,
    error
  } = t0;
  const required = t1 === undefined ? false : t1;
  const {
    t
  } = useLocoTranslation();
  const t2 = `flex flex-col gap-1 text-sm font-medium ${wrapperClassName || ""}`;
  let t3;
  if ($[0] !== label || $[1] !== labelClassName || $[2] !== required) {
    t3 = <FieldLabel label={label} labelClassName={labelClassName} required={required} />;
    $[0] = label;
    $[1] = labelClassName;
    $[2] = required;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `focus-within:border-brand-primary main-transition-colors flex w-fit rounded-lg ${error ? "border-danger" : "border-text-secondary/30"} border-text-secondary/30 border ${isFetching && "bg-skeleton-primary/40 animate-pulse"}`;
  let t5;
  if ($[4] !== onChange) {
    t5 = e => {
      const newValue = e.target.valueAsNumber;
      if (newValue > 100) {
        onChange(100);
      } else {
        if (newValue < 0) {
          onChange(0);
        }
      }
      onChange(newValue);
    };
    $[4] = onChange;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isFetching || $[7] !== t5 || $[8] !== value) {
    t6 = <input value={value} disabled={isFetching} type="number" onChange={t5} className="main-transition-colors text-text-primary focus:border-brand-primary placeholder:text-text-tertiary/70 peer w-[66px] rounded-lg px-4 py-2.5 focus:outline-hidden" />;
    $[6] = isFetching;
    $[7] = t5;
    $[8] = value;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t || $[11] !== value) {
    t7 = value > 1 ? t("dashboard.transactions.sub_interval.days") : t("dashboard.transactions.sub_interval.day");
    $[10] = t;
    $[11] = value;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div className="bg-background-primary flex w-fit w-fit items-center justify-center rounded-r-lg px-4 py-2.5">{t7}</div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t8) {
    t9 = <div className={t4}>{t6}{t8}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== error) {
    t10 = <FieldErrorAndDescription error={error} />;
    $[19] = error;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2 || $[23] !== t3 || $[24] !== t9) {
    t11 = <div className={t2}>{t3}{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t2;
    $[23] = t3;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
export default DeadlineSettingsExpirationInput;